<template>
    <div>
        <div v-if="loading" class="loading"/>

        <div class="top-right-button-container">
            <b-button v-b-modal.vendor_form @click="edit = false" variant="primary" size="sm" class="top-right-button"
                      v-text="'ADD NEW'"/>
        </div>

        <div class="d-flex flex-row">
            <span class="iconsminds-hotel mr-3 menu-icon-style" style="font-size: 23px;"/>

            <piaf-breadcrumb heading="Vendors"/>
<!--            <p class="my-auto">-->
<!--                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet commodi dolores quod,-->
<!--                repellendus similique sint. Ad, corporis culpa delectus est in ipsum laboriosam nostrum-->
<!--                officiis quia quos rem totam vitae.-->
<!--            </p>-->
        </div>

        <div class="my-2">
            <div class="d-block d-md-inline-block pt-1">
                <b-dropdown :text="'Order by: ' + meta.order_by"
                            variant="outline-dark" class="mr-1 float-md-left btn-group" size="xs">

                    <b-dropdown-item v-for="(field,index) in table_fields.slice(0, -1)"
                                     v-if="field.sortable === true" :key="index"
                                     @click="changeOrderBy(field.key, field.label)">{{ field.label }}
                    </b-dropdown-item>
                </b-dropdown>

                <div class="search-sm d-inline-block float-md-left ml-1 align-top">
                    <b-input placeholder="Search" @input="searchVendor" v-model="meta.search"/>
                </div>
            </div>

            <div class="float-md-right pt-1">
                <span class="text-muted text-small mr-1 mb-2">{{meta.from}}-{{meta.to}} of {{ meta.total }}</span>

                <b-dropdown right :text="meta.per_page.toString()" variant="outline-dark"
                            class="d-inline-block" size="xs">
                    <b-dropdown-item v-for="(size,index) in meta.page_sizes" :key="index"
                                     @click="changePageSize(size)">{{ size }}
                    </b-dropdown-item>
                </b-dropdown>
            </div>
        </div>

        <div class="separator mb-4"/>

        <b-card class="mb-4" :title="'List of Vendors'">
            <b-refresh-button class="text-data-link" @click="refreshData"/>

            <b-table :key="tableKey" show-empty no-sort-reset class="vuetable" :sort-by="meta.sort_by"
                     :sort-desc="meta.sort_desc" @sort-changed="changeSorting" :per-page="meta.per_page"
                     :current-page="meta.current_page" :fields="table_fields" :items="fetchVendors">
                <template v-slot:cell(id)="data">
                    <span v-text="data.item.data.attributes.code"/>
                </template>

                <template v-slot:cell(name)="data">
                    <router-link class="text-data-link" :to="data.item.links.self"
                                 v-text="data.item.data.attributes.name"/>
                </template>

                <template v-slot:cell(address)="data">
                    <span v-text="data.item.data.attributes.address"/>
                </template>

                <template v-slot:cell(phone)="data">
                    <span v-text="data.item.data.attributes.phone"/>
                </template>

                <template v-slot:cell(active)="data">
                    <b-badge pill style="width: 58px;"
                             :variant="data.item.data.attributes.status === 'Active' ? 'info' : 'danger'">
                        {{ data.item.data.attributes.status }}
                    </b-badge>
                </template>

                <template v-slot:cell(actions)="data">
                    <b-dropdown variant="empty" class="my-auto dropright" size="xs"
                                menu-class="mt-2" style="width: 75px;" right no-caret>
                        <template slot="button-content">
                            <i class="btn-circle simple-icon-options-vertical"/>
                        </template>

                        <b-dropdown-item :to="data.item.links.self">
                            Summary
                        </b-dropdown-item>

                        <b-dropdown-item @click="changeStatus(data.item)">
                            Change Status
                        </b-dropdown-item>

                        <b-dropdown-item @click="editVendor(data.item.vendor_id)">
                            Edit
                        </b-dropdown-item>

                        <b-dropdown-item @click="deleteVendor(data.item)">
                            Delete
                        </b-dropdown-item>
                    </b-dropdown>
                </template>
            </b-table>

            <b-pagination size="sm" align="center" :total-rows="meta.total" :per-page="meta.per_page"
                          v-model="meta.current_page">
                <template v-slot:next-text>
                    <i class="simple-icon-arrow-right"/>
                </template>

                <template v-slot:prev-text>
                    <i class="simple-icon-arrow-left"/>
                </template>

                <template v-slot:first-text>
                    <i class="simple-icon-control-start"/>
                </template>

                <template v-slot:last-text>
                    <i class="simple-icon-control-end"/>
                </template>
            </b-pagination>
        </b-card>

        <VendorFormModal :edit="edit" @updated="tableKey++"/>

        <VendorOtherModal v-if="vendor" :vendor="vendor" mode="status" :current-status="currentStatus" @updated="handleStatusUpdate"/>

        <VendorDeleteModal v-if="vendor" mode="vendor" :vendor="vendor" @deleted-vendor="tableKey++"/>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import _ from 'lodash';

    import VendorFormModal from "./modals/VendorFormModal";
    import VendorOtherModal from "./modals/VendorOtherModal";
    import VendorDeleteModal from "./modals/VendorDeleteModal";

    export default {
        name: "VendorsList",
        components: {
            VendorFormModal,
            VendorOtherModal,
            VendorDeleteModal,
        },
        data() {
            return {
                loading: true,
                tableKey: 0,
                edit: false,
                vendor: null,
                currentStatus: false,
            }
        },

        mounted() {
            this.$store.commit('resetVendorsMeta');
        },

        computed: {
            ...mapGetters({
                table_fields: 'getVendorTableFields',
                meta: 'getVendorsMeta',
            }),
        },

        methods: {
            editVendor(vendor_id) {
                this.edit = true;

                this.$store.dispatch('fetchEditVendor', vendor_id)
                    .finally(response => {
                        this.$bvModal.show('vendor_form');
                    });
            },

            async changeStatus(vendor) {
                this.vendor = vendor;

                await this.$store.dispatch('fetchVendor', vendor.vendor_id);
                this.currentStatus = this.vendor.data.attributes.status.toLowerCase() === 'active';

                setTimeout(() => {
                    this.$bvModal.show('vendor_other');
                }, 1);
            },

            handleStatusUpdate(newStatus) {
                this.tableKey++
                this.currentStatus = newStatus;
            },

            deleteVendor(vendor) {
                this.vendor = vendor;

                setTimeout(() => {
                    this.$bvModal.show('vendor_delete');
                }, 1);
            },

            changeSorting(event) {
                (event.sortDesc ? this.meta.sort = 'desc' : this.meta.sort = 'asc') && (this.meta.sort_by = event.sortBy);
            },

            changeOrderBy(key, label) {
                this.meta.order_by = label;
                this.meta.sort_by = key;
            },

            changePageSize(per_page) {
                this.meta.per_page = per_page;
            },

            searchVendor: _.debounce(function (event) {
                // if (this.meta.search && this.meta.search.length >= 3) {
                    this.meta.current_page === 1 ? this.tableKey++ : this.meta.current_page = 1;
                // }
            }, 300),

            refreshData() {
                this.$store.commit('resetVendorsMeta');
                this.meta.current_page === 1 ? this.tableKey++ : this.meta.current_page = 1;
            },

            fetchVendors() {
                return this.$store.dispatch('fetchVendors')
                    .then(vendors => {
                        return vendors.data;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
        },
    }
</script>

<style scoped>

</style>
